/** The product's name as people see it (page title, sign-in, footer, tours, the assistant). Change it here. */
export const APP_NAME = "BuildNexa";
